import { render, staticRenderFns } from "./ProtocolContent.vue?vue&type=template&id=38df2f5b&scoped=true&"
import script from "./ProtocolContent.vue?vue&type=script&lang=js&"
export * from "./ProtocolContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df2f5b",
  null
  
)

export default component.exports